// 借入相談変更中（完了）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import HeadingM from '../../molecules/HeadingM';
import { StepNavigation as StepType } from '../../types/Template';
import FooterPreExaminationApplicationInputComplete from '../../organisms/FooterPreExaminationApplicationInputComplete';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  guide_text: string;
  is_staff: boolean;
  opened_mypage: boolean;
  guarantors_num: number;
}

const BorrowingConsultationChangeFinish: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  guide_text,
  is_staff,
  opened_mypage,
  guarantors_num,
}) => {
  // 完了メッセージ
  const setCompletedMsg = () => {
    // 連帯債務者等ありの場合
    if (guarantors_num > 0) {
      return (
        <div className="p-lead">
          借入相談の変更を完了しました。
          <br />
          またご登録の連帯債務者等の方に申込内容確認のためのマイページ開設招待メールを送信しました。
          <br />
          連帯債務者等がいる場合、現在は申込処理は完了していません。連帯債務者等による申込内容の確認と同意が完了すると、JAへの申込処理が完了します。
          <br />
          連帯債務者等の確認状況はマイページから確認可能です。
          <br />
          連帯債務者等の方にメールが届かない場合にはマイページから本申込み案件を開き、メールの再送信を行って下さい。
          <br />
          本お取引におけるJAからのメールについては、「no-reply@entry.ja-netloan.jp」からのみ送信されます。
        </div>
      );
    }

    // 連帯債務者等なしの場合
    return (
      <div className="p-lead">
        借入相談の変更を完了しました。
        <br />
        本お取引におけるJAからのメールについては、「no-reply@entry.ja-netloan.jp」からのみ送信されます。
      </div>
    );
  };

  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={false}
        guide_text={guide_text}
        display_status={false}
      />
      <HeadingM label="借入相談変更完了"></HeadingM>
      {setCompletedMsg()}
      <FooterPreExaminationApplicationInputComplete
        is_staff={is_staff}
        opened_mypage={opened_mypage}
      />
    </>
  );
};

export default BorrowingConsultationChangeFinish;
